import { createSelector } from '@reduxjs/toolkit';
import {
  FEATURE_TYPE,
  selectApp,
  selectFeatureTypes,
  SELECTOR,
  selectSplitApiKey,
  setSelector,
} from '@socialive/common';

// NOTE: Overriding the default implementation, because we need to load app features without account/user.
const selectSplitInit = createSelector(
  selectFeatureTypes,
  selectSplitApiKey,
  selectApp,
  (featureTypes, authorizationKey, app) =>
    authorizationKey &&
    (!featureTypes?.[FEATURE_TYPE.APP] || app) && {
      authorizationKey,
      app,
      featureTypes,
    }
);

setSelector(SELECTOR.SPLIT_INIT, selectSplitInit);

export default selectSplitInit;
